// src/api/usersApi.js
import apiClient from './apiClient';

const usersApi = {
  // 📌 Obtener todos los usuarios de una empresa
  getUsersByCompany: async (companyId) => {
    try {
      const response = await apiClient.get(`/users/company/${companyId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo usuarios de empresa:', error);
      throw error;
    }
  },

  // 📌 Obtener un solo usuario por ID
  getUserById: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo usuario:', error);
      throw error;
    }
  },

  // 📌 Obtener un solo usuario por username
  getUserByUsername: async (username) => {
    try {
      const response = await apiClient.get(`/users/byusername/${username}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo usuario por username:', error);
      throw error;
    }
  },

  // 📌 Crear un nuevo usuario (admin o similar)
  createUser: async (userData) => {
    try {
      const response = await apiClient.post('/users', userData);
      return response.data;
    } catch (error) {
      console.error('Error creando usuario:', error);
      throw error;
    }
  },

  // 📌 Crear un usuario “gratuito” (respondant)
  createFreeUser: async (userData) => {
    try {
      const response = await apiClient.post('/users/respondants', userData);
      return response.data;
    } catch (error) {
      console.error('Error creando usuario gratuito:', error);
      throw error;
    }
  },

  // 📌 Crear super administrador (sólo root user)
  createSuperuser: async (username) => {
    try {
      const response = await apiClient.post('/users/root/create-superuser', { username });
      return response.data;
    } catch (error) {
      console.error('Error creando super administrador:', error);
      throw error;
    }
  },

  // 📌 Obtener todos los administradores (root user y super admin)
  getAdmins: async () => {
    try {
      const response = await apiClient.get('/users/role/admin');
      return response.data.admins;
    } catch (error) {
      console.error('Error obteniendo administradores:', error);
      throw error;
    }
  },

  // 📌 Obtener todos los usuarios nutriólogos (root user y super admin)
  getNutriologists: async () => {
    try {
      const response = await apiClient.get('/users/role/nutriology');
      return response.data.admins;
    } catch (error) {
      console.error('Error obteniendo nutriólogas:', error);
      throw error;
    }
  },

  // 📌 Obtener nombre público de nutrióloga para review
  getPublicNutriologyName: async (nutriologyId) => {
    try {
      const response = await apiClient.get(`/users/public/nutriology/${nutriologyId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo nombre público de nutrióloga:', error);
      throw error;
    }
  },

  // 📌 Obtener todos los super administradores (sólo root user)
  getSuperAdmins: async () => {
    try {
      const response = await apiClient.get('/users/root/superadmin');
      return response.data.superAdmins;
    } catch (error) {
      console.error('Error obteniendo super administradores:', error);
      throw error;
    }
  },

  // 📌 Actualizar usuario
  updateUser: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error actualizando usuario:', error);
      throw error;
    }
  },

  // 📌 Resetear contraseña de un usuario (genera una genérica de un solo uso)
  resetUserPassword: async (userId) => {
    try {
      const response = await apiClient.post(`/users/${userId}/reset-password`);
      return response.data;
    } catch (error) {
      console.error('Error reseteando contraseña:', error);
      throw error;
    }
  },

  // 📌 Solicitar correo de cambio de contraseña para un usuario
  requestPasswordReset: async (email) => {
    try {
      const response = await apiClient.post('/users/password-reset-request', { email });
      return response.data;
    } catch (error) {
      console.error('Error enviando correo de recuperación:', error);
      throw error;
    }
  },

  // 📌 Eliminar usuario
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error eliminando usuario:', error);
      throw error;
    }
  },

  // 📌 Obtener HRA responses (companyId opcional)
  getHRAResponses: async (companyId) => {
    try {
      const response = await apiClient.get('/users/company/user/hraResponses', {
        params: companyId ? { companyId } : {}
      });
      return response.data;
    } catch (error) {
      console.error('Error obteniendo HRA responses:', error);
      throw error;
    }
  },

  // 📌 Obtener estrés responses (companyId opcional)
  getEstresResponses: async (companyId) => {
    try {
      const response = await apiClient.get('/users/company/user/estresResponses', {
        params: companyId ? { companyId } : {}
      });
      return response.data;
    } catch (error) {
      console.error('Error obteniendo estrés responses:', error);
      throw error;
    }
  },

  // 📌 Obtener respuestas HB (companyId opcional)
  getHBResponses: async (companyId) => {
    try {
      const response = await apiClient.get('/users/company/user/hbResponses', {
        params: companyId ? { companyId } : {}
      });
      return response.data;
    } catch (error) {
      console.error('Error obteniendo HB responses:', error);
      throw error;
    }
  }
};

export default usersApi;
